module.exports = __webpack_public_path__ + "static/vue-059c9bb6e47127a4a7bbcb754d09abcc.svg";